export default __webpack_public_path__ + "static/media/december.217573a9.jpg";